// Copied from src/v2/newEngineLogic.js by web-app/scervWeb/scripts/sync-engine-shared.js.
// Edit the original; this copy is refreshed on every start and build.
// Pure decision logic for the per-restaurant "new engine" switch. No React,
// no Firebase: tests load this file directly.
//
// The switch lives where every other restaurant feature lives:
//   restaurants/{id}.features.newEngine  (boolean, default false: opt-in)
// written only by the Scerv admin portal (saveRestaurantFeatureEntitlements),
// which also records featureEntitlements.newEngine. Guests and staff read it
// from the public projection restaurantPublic/{id}.features.newEngine.

export const NEW_ENGINE_FEATURE = "newEngine";

const ENTITLEMENT_SOURCES = ["featureEntitlements", "subscriptionFeatures", "planFeatures", "platformFeatures", "entitlements"];

// True only when the restaurant explicitly opted in. Unlike V1 features there
// is no style default: a missing or non-boolean value means off, and an
// entitlement set to false clamps it off.
export function isNewEngineOn(restaurant) {
	if (!restaurant || typeof restaurant !== "object") return false;
	const features = restaurant.features && typeof restaurant.features === "object" ? restaurant.features : {};
	if (features[NEW_ENGINE_FEATURE] !== true) return false;
	return !ENTITLEMENT_SOURCES.some((key) => (restaurant[key] || {})[NEW_ENGINE_FEATURE] === false);
}

export const hasV2Gateway = (gatewayUrl) => typeof gatewayUrl === "string" && /^https?:\/\/\S+$/.test(gatewayUrl.trim());

// The whole decision: a build without a V2 gateway URL never runs the new
// engine, whatever the restaurant doc says.
export function shouldUseNewEngine({ restaurant, gatewayUrl } = {}) {
	return hasV2Gateway(gatewayUrl) && isNewEngineOn(restaurant);
}

// The Stripe publishable key the engine's payment sheets may use: live only
// in the production build on scervmvp (where the gateway charges with the live
// key), test everywhere else. Anything else is refused, so a sheet never runs
// in a mode that does not match the gateway's charges.
export function engineStripeKey(key, extra) {
	if (typeof key !== "string") return null;
	const live = extra?.appEnv === "production" && extra?.firebase?.projectId === "scervmvp";
	return (live ? /^pk_live_[A-Za-z0-9]+$/ : /^pk_test_[A-Za-z0-9]+$/).test(key) ? key : null;
}
